import { makeStyles, tokens } from '@fluentui/react-components';

export const useUserAvatarStyles = makeStyles({
  base: { cursor: 'pointer' },
  small: { fontSize: tokens.fontSizeBase500 },
  medium: { fontSize: tokens.fontSizeHero700 },
  large: { fontSize: tokens.fontSizeHero1000 },
});
